const cardRetOptions = [
  {
    "key": "DEVICE_CANNOT_RETAIN_CARD",
    "text": "Device cannot retain card"
  },
  {
    "key": "DEVICE_CAN_RETAIN_CARD",
    "text": "Device can retain card"
  },
];

export default cardRetOptions;
